import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import moment from 'moment/moment'
import { apiProjectsList, apiProjectsView } from 'Services/UserService'

export const getData = createAsyncThunk('user/projects/getData', async datas => {
    const { data } = await apiProjectsList(datas)
    return data
})

export const getView = createAsyncThunk('user/projects/getView', async datas => {
    var id = datas.id ? datas.id : datas.clone_id
    if (!id) return viewData
    const { data } = await apiProjectsView(id)
    if (!datas.id) {
        ;['name', 'purchase_order_no'].map(key => {
            data[key] = ''
            return key
        })
    }
    data.authorised_id = (data.authoriseds ?? []).map(e => e.user_id)
    data.qc_manager_id = (data.qc_managers ?? []).map(e => e.user_id)
    data.qc_inspector_id = (data.qc_inspectors ?? []).map(e => e.user_id)
    data.test_manager_id = (data.test_managers ?? []).map(e => e.user_id)
    data.tester_id = (data.testers ?? []).map(e => e.user_id)
    data.marketing_id = (data.marketings ?? []).map(e => e.user_id)
    data.customer_id = (data.customers ?? []).map(e => e.customer_id)
    return data
})

const viewData = {
    authorised_id: [],
    qc_manager_id: [],
    qc_inspector_id: [],
    test_manager_id: [],
    tester_id: [],
    marketing_id: [],
    customer_id: [],
    tracker: '',
    name: '',
    location: '',
    purchase_order_no: '',
    l_o_a_no: '',
    order_receipt_date: moment().format('YYYY-MM-DD'),
    manufacturer: 'INDO TECH TRANSFORMERS LTD, Kanchipuram-631 561',
    contractor: '',
    epc_contractor: '',
    sub_contractor: '',
    consultant: '',
    end_customer: '',
    work_order_no: '',
    serial_number: '',
    authorised: 0,
}

export const projectsSlice = createSlice({
    name: 'user/projects',
    initialState: {
        loading: true,
        view: viewData,
        data: [],
        total: 0,
        table: {
            page: 1,
            length: 10,
            search: '',
            column: '',
            dir: '',
            status: 1,
            start: moment().startOf('year').locale('en').format('YYYY-MM-DD'),
            end: moment().endOf('year').locale('en').format('YYYY-MM-DD'),
        },
    },
    reducers: {
        setData: (state, { payload }) => {
            state.data = payload
        },
        setTableData: (state, { payload }) => {
            state.table = payload
        },
        setDate: (state, { payload: { start, end } }) => {
            state.table.page = 1
            state.table.start = start
            state.table.end = end
        },
    },
    extraReducers: builder => {
        builder
            .addCase(getData.pending, state => {
                state.loading = true
            })
            .addCase(getData.fulfilled, (state, { payload }) => {
                state.loading = false
                state.data = payload.data
                state.total = payload.total
            })
            .addCase(getData.rejected, state => {
                state.loading = false
                state.data = []
                state.total = 0
            })
            .addCase(getView.pending, state => {
                state.loading = true
                state.view = viewData
            })
            .addCase(getView.fulfilled, (state, { payload }) => {
                state.loading = false
                state.view = payload
            })
    },
})

export const { setData, setTableData, setDate } = projectsSlice.actions

export default projectsSlice.reducer
